"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.catalogueDynamicUrl = void 0;
var _fetching = require("@ori/fetching");
/* istanbul ignore file @preserve */

const catalogueDynamicUrl = exports.catalogueDynamicUrl = (0, _fetching.gql)`
  query CatalogueDynamicUrl($pageNumber: Int = 1, $storeName: ID, $catalogueId: String!) {
    application {
      sharingLinks {
        otherCatalogue(catalogueId: $catalogueId, pageNumber: $pageNumber) {
          title
          relativeUrl
          dynamicSharingUrl(storeName: $storeName)
        }
      }
    }
  }
`;
